import {useEffect, useState} from "react";

type Props = {
    maxCount?:number
    minCount?:number
    stride?:number
    startNum:number
    changeNum:React.Dispatch<React.SetStateAction<number>>
}
export default function ProductCount(props:Props){
    const maxCount = props.maxCount || 10000;
    const minCount = props.minCount || 1;
    const stride = props.stride || 1;  //点击一次加几
    const startNum = props.startNum || 1;  //起始数量

    // const [currentNum, setCurrentNum] = useState(startNum) //当前商品数
    const reduceCountAction = () => {
        // 限制在最小数
        if(startNum <= minCount)return
        props.changeNum(startNum - stride)
        // setCurrentNum(currentNum - stride)

    }
    const addCountAction = () => {
        // 限制在最大数
        if(startNum >= maxCount)return
        props.changeNum(startNum + stride)
        // setCurrentNum(currentNum + stride)
    }
    useEffect(() => {
        if(startNum < 1){
            props.changeNum(1)
        }
        if(startNum > maxCount){
            props.changeNum(maxCount)
        }
    }, [startNum]);

    return <div className='c-flex border-[#999] border select-none  mx-2'>
        <p className='bg-[#f0f0f0] text-[20px] w-[40px] h-[40px] c-flex border-r border-[#999] cursor-pointer hover:text-main'
              onClick={reduceCountAction}
        >
            <span>-</span>
        </p>

        <input type={'number'} value={startNum} onChange={(e)=>props.changeNum(parseInt(e.target.value))} className='text-center w-12'></input>

        <p className='bg-[#f0f0f0] text-[20px] w-[40px] h-[40px] c-flex border-l border-[#999] cursor-pointer hover:text-main'
              onClick={addCountAction}
        >
            <span>+</span>
        </p>
    </div>
}